class ProductSupplyModalController extends AbstractController
	@register()
	@inject '$uibModalInstance',
		'productNumberInPackage'
		'suppliers'
		'entity'
		'isProduct'
		'onChange'
		'attributesService'
